import React from "react";
import storeHero from "../../assets/images/store-hero.png";
import item1 from "../../assets/images/item1.png";
import item2 from "../../assets/images/item2.png";
// import item3 from "../../assets/images/item3.png";
import arrow from "../../assets/images/arrow.png";
import { useNavigate } from "react-router-dom";

const storeCategories = [
  {
    id: 1,
    className: "fresh-card",
    title: "FRESH & GREEN",
    description: "From crisp veggies to leafy greens, get produce that’s always market-fresh.",
    linkText: "EXPLORE PRODUCE",
    image: item1,
    alt: "Fresh vegetables",
  },
  {
    id: 2,
    className: "snack-card",
    title: "SNACK BREAK",
    description: "Sweet, salty, or spicy — discover the treats you won’t stop munching on.",
    linkText: "BROWSE SNACKS",
    image: item2,
    alt: "Snack basket",
  },
  {
    id: 3,
    className: "care-card",
    title: "HOME & CARE",
    description: "Everything your home needs — from cleaning supplies to self-care essentials.",
    linkText: "SHOP ESSENTIALS",
    image: "",
    alt: "Home care products",
  },
];

export default function StoreHero() {
  const navigate = useNavigate();

  return (
    <section className="store-hero-section">
      <div className="wrapper">
        <div className="store-main-hero">
          <div className="store-main-content">
            <h1>EVERYDAY ESSENTIALS, ALL IN ONE PLACE</h1>
            <p>Stock your kitchen with all the everyday essentials — grains, spices, oils, and more.</p>

            <button type="button" className="store-main-btn" onClick={() => navigate("/store/vendors")}>
              EXPLORE PRODUCTS
            </button>
          </div>

          <img src={storeHero} alt="Grocery cart" className="store-hero-cart" />
        </div>

        <div className="store-category-grid">
          {storeCategories.map((item) => (
            <div key={item.id} className={`store-category-card ${item.className}`}>
              <div className="store-category-content">
                <h2>{item.title}</h2>
                <p>{item.description}</p>
                <button type="button" className="store-category-link" onClick={() => navigate("/store/vendors")}>
                  {item.linkText}
                  <img src={arrow} width={18} height={11} />
                </button>
              </div>
              {item.className !== "care-card" ? <img className="store-items-img" src={item.image} alt={item.alt} /> : <></>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
